var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"containerStyle1",attrs:{"md10":"","lg10":"","xs12":"","sm12":""}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.img1}})])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86ab477a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/TemplateDge.vue
// module id = null
// module chunks = 